export default __webpack_public_path__ + "static/media/Promo-Facebook-Facebook image post.97dbbc87.jpeg";